import { Link } from 'react-router';
import { FilePath } from '../../../services/utilities';
import HomePageCards from '../home-cards';

const TitleOneExchangeHome = () => {

    return (
        <div>
            <h1 className="text-center">TitleOne Exchange</h1>
            <p>For over 25 years, TitleOne Exchange has been a trusted qualified intermediary in the 1031 exchange process. We specialize in helping investors defer capital gains tax on the sale of their business or investment properties, ensuring a smooth and efficient transaction. Our team is dedicated to providing personalized guidance and support throughout the entire exchange process. TitleOne Exchange offers <Link to="/1031-exchange/contact-us">complimentary consultations</Link> to address all your concerns and help you make informed decisions.</p>
            <HomePageCards />
            <h2 className="titleone-exchange-h2">Interested in deferring taxes with a 1031 exchange?</h2>
            <img src={FilePath("/images/titleone-exchange/exchange-home.webp")} alt="1031 Exchange" className="img-fluid float-end p-3" width="450" height="290" />
           
            <p>If you are planning to sell real estate investment property and would like to defer potential capital gains tax, you should <Link to="/1031-exchange/basics">consider the benefits of participating in a tax-deferred 1031 exchange</Link>. View our <Link to="/1031-exchange/tools">FAQs</Link> to learn more about the 1031 exchange process.</p>

            <p>There are many benefits to using TitleOne Exchange:</p>

            <ul>
                <li>Ability to execute exchanges nation-wide</li>
                <li>With our <Link to="/1031-exchange/tools">Proceeds Protection Protocol</Link>, we treat your money like it's our own</li>
                <li>Fidelity coverage maintained in the amount of $5,000,000</li>
                <li>Errors & Omissions coverage in the amount of $5,000,000</li>
                <li><Link to="/1031-exchange/tools">Tools and tips for Exchangors and Brokers</Link></li>
                <li>Most valuable is our expertise. Our <Link to="/1031-exchange/contact-us">dedicated staff</Link> has extensive knowledge on a wide variety of topics</li>
                <li>Have questions? TitleOne Exchange offers complimentary consultations &mdash; <Link to="/1031-exchange/contact-us">Contact us today</Link>. We look forward to discussing strategies on deferring long term capital gains and more.</li>
            </ul>

        </div>
    );
}

export default TitleOneExchangeHome;